export const hideNull = (value) => {
  if (value === null || value === undefined) return 'n/a';

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return value;
};
